export default {

	newsType: {
		1: 'News',
		2: 'Case',
		3: 'Testimonial'
	}

}